import { yup } from 'straightline-utils/validation';

export default (app) => {
  return yup.object({
    shipment_quote_id: yup.string().id().label('Shipment Quote ID').required(),
    rate_id: yup.string().trim().label('Rate ID').required(),
    amount: yup
      .number()
      .integer()
      .positive()
      .round()
      .label('Offer Amount')
      .required(),
    notes: yup.string().trim().nullable().label('Notes')
  });
};
